/**
 * SCSS IMPORT FILE
 * this file is just for scss imports which will create css classes
 */
import '@swisslife/shared-ui/src/base/bootstrap/css/bootstrap';
import '../../../atoms/link/css/link';
import './social-links.scss';
import './modifier/social-links-channels.scss';
import './modifier/social-links-sign-on.scss';
import './modifier/social-links-disabled.scss';
